import { useState } from "react";
import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import ArticleCard from "@/components/feature/ArticleCard";
import { getArticlesByCategory, getLatestArticles } from "@/utils/content";

const tabs = [{ slug: "all", name: "全部" }, ...categories.map((c) => ({ slug: c.slug, name: c.name }))];

export default function LatestNews() {
  const [active, setActive] = useState("all");

  const list = (active === "all" ? getLatestArticles() : getArticlesByCategory(active)).slice(0, 6);

  return (
    <section>
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className="h-5 w-1 rounded-full bg-primary-500" />
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">最新资讯</h2>
        </div>
        {active !== "all" && (
          <Link
            to={`/category/${active}`}
            className="whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部 <i className="ri-arrow-right-s-line" />
          </Link>
        )}
      </div>

      <div className="mb-5 flex flex-wrap gap-1 rounded-full bg-background-200/70 p-1">
        {tabs.map((t) => (
          <button
            key={t.slug}
            type="button"
            onClick={() => setActive(t.slug)}
            className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              active === t.slug
                ? "bg-primary-500 text-background-50"
                : "text-foreground-600 hover:text-primary-600"
            }`}
          >
            {t.name}
          </button>
        ))}
      </div>

      <div className="flex flex-col gap-4">
        {list.map((a) => (
          <ArticleCard key={a.id} article={a} variant="list" />
        ))}
      </div>
    </section>
  );
}